module.exports = __webpack_public_path__ + "static/img/h4-2.d2fd53c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd116/h4-2.png
// module id = CoOX
// module chunks = 1